import React from 'react';
import { LoadingButton } from '@mui/lab';
import { styled } from '@mui/material/styles';

const variantDsl = {
  tertiary: 'text',
};

const LoadingButtonComponent = ({ variant, size, ...props }) => (
  <LoadingButton variant={variantDsl[variant]} size={size} {...props} />
);

const PWDKLoadingButton = styled(LoadingButtonComponent)(
  ({ theme, variant, size, loading, disabled }) => {
    let globalStyling = {
      padding: '8px 16px',
    };

    if (size === 'small') {
      globalStyling = {
        ...globalStyling,
        ...theme.typography.caption1,
      };
    }

    if (size === 'medium') {
      globalStyling = {
        ...globalStyling,
        ...theme.typography.subheading4medium,
      };
    }

    if (size === 'large') {
      globalStyling = {
        ...globalStyling,
        padding: '12px 24px',
        ...theme.typography.subheading3medium,
      };
    }

    if (variant === 'primary') {
      return {
        ...globalStyling,
        color: theme.palette.neutralWhite.main,
        backgroundColor: theme.palette.neutral.main,

        '&:hover': {
          color: theme.palette.neutral.main,
          backgroundColor: theme.palette.primary400.main,
        },
        '&:active': {
          color: theme.palette.neutral.main,
          backgroundColor: theme.palette.primary300.main,
        },
        '&:disabled': {
          color: disabled && theme.palette.neutral500.main,
          backgroundColor: theme.palette.neutral700.main,
        },
      };
    }

    if (variant === 'tertiary') {
      return {
        color: theme.palette.primaryBrandPurwadhika.main,
        borderRadius: 0,
        borderBottom: `1px solid ${theme.palette.primary300.main}`,
        ...globalStyling,
        padding: 0,
        '&:hover': {
          borderBottom: `1px solid ${theme.palette.primaryBrandPurwadhika.main}`,
        },
        '&:active': {
          borderBottom: `1px solid ${theme.palette.primary300.main}`,
        },
        '&:disabled': {
          color: disabled && theme.palette.neutral500.main,
          borderBottom: `1px solid ${theme.palette.neutral500.main}`,
        },
      };
    }

    if (variant === 'secondary') {
      return {
        ...globalStyling,
        color: theme.palette.neutral100.main,
        backgroundColor: 'transparent',
        boxShadow: `inset 0 0 0 1px ${theme.palette.neutral300.main}`,
        '&:hover': {
          backgroundColor: theme.palette.neutral900.main,
          boxShadow: `inset 0 0 0 2px ${theme.palette.neutral100.main}`,
        },
        '&:active': {
          backgroundColor: theme.palette.neutral900.main,
          boxShadow: `inset 0 0 0 2px ${theme.palette.neutral100.main}`,
        },
        '&:disabled': {
          color: disabled && theme.palette.neutral500.main,
          boxShadow: `inset 0 0 0 1px ${theme.palette.neutral600.main}`,
          backgroundColor: theme.palette.neutral900.main,
        },
      };
    }
    if (variant === 'ghost') {
      return {
        ...globalStyling,
        color: theme.palette.neutral100.main,
        backgroundColor: theme.palette.neutral900.main,

        '&:hover': {
          backgroundColor: theme.palette.neutral700.main,
        },
        '&:active': {
          backgroundColor: theme.palette.neutral500.main,
        },
        '&:disabled': {
          color: disabled && theme.palette.neutral500.main,
          backgroundColor: theme.palette.neutral900.main,
        },
      };
    }

    return { ...globalStyling };
  },
);

export default PWDKLoadingButton;
